import { useMemo, useState } from "react";
import { Container, Button, InputGroup, Input } from "reactstrap";
import { useQuery } from "react-query";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import AddMeetings from "./AddMeetings";
import {
  deleteClickHandler,
  extractMeetingData,
  modalHandler,
  onEditClickHandler,
  setCurrentPageMeeting,
} from "./AddMeetings/AddMeetingsMethods/AddMeetingsModalMethods";
import { handleAdminMeetingSearch } from "./MeetingsMethods";
import { getMeetingDetails } from "../../../../Api/AdminApis";
import CardsWithTable from "../../../../Components/Containers/CardsWithTable";
import ModalContainer from "../../../../Components/Containers/ModalContainer/ModalContainer";
import { usePermission } from "../../../../Components/Permissions/Admin/AdminPermission";

const MeetingsIndex = () => {
  const { currentPage = "1" } = useParams();
  const navigate = useNavigate();
  const { pathname } = useLocation()
  const [isOpen, setIsOpen] = useState(false);
  const [modalEditData, setModalEditData] = useState<any>([]); // data for edit modal
  const [searchQuery, setSearchQuery] = useState<string>("");
  const { checkPermission } = usePermission();

  const {
    data: meeting,
    error: meetingError,
    isLoading: meetingLoading,
    refetch: meetingListRefetch,
  }: any = useQuery(
    [`meeting${currentPage + searchQuery}`, currentPage, searchQuery],
    () => getMeetingDetails(currentPage, searchQuery),
    { keepPreviousData: true }
  );

  const meetingData = useMemo(() => extractMeetingData(meeting), [meeting]);

  return (
    <section>
      <div className="content-outer-wrap">
        <Container>
          <div className="search-bar-full-wrap">
            <div className="search-bar">
              <InputGroup>
                <Input
                  placeholder="Search here..."
                  onChange={(e) =>
                    handleAdminMeetingSearch(e, setSearchQuery, navigate)
                  }
                />
                <span className="icon-container">
                  <i className="icon xl icon-search"></i>
                </span>
              </InputGroup>
            </div>
            <div className="right-side-wrap">
              <div className="filter-wrap">
                <div className="button-wrap">
                  {checkPermission("meetings:write") ? <Button
                    onClick={() => modalHandler(setModalEditData, setIsOpen)}
                    color="primary"
                    className="sm"
                  >
                    <i className="icon icon-add-new xl"></i>Meeting
                  </Button> : null}
                </div>
              </div>
            </div>
          </div>
          {/* cards section */}
          <div className="content-list-outer-wrap">
            <CardsWithTable
              data={meetingData}
              tableTitle="Meeting Details"
              tableFields={[
                "Meeting Type",
                "Meeting Title",
                "Start Date & Time",
                "End Date & Time",
              ]}
              Arraykeys={[
                "meetings_type", "meetings_title",
                "meetings_start_date", "meetings_end_date"]}
              viewType="table"
              toURL={""}
              // actions={["edit", "delete"]}
              actions={[
                checkPermission("meetings:write") ? "edit" : "",
                checkPermission("meetings:delete") ? "delete" : "",
              ]}
              isLoading={meetingLoading}
              error={meetingError}
              onEditClick={(selectedId: any) => {
                if (checkPermission("meetings:write")) {
                  onEditClickHandler(
                    selectedId,
                    setModalEditData,
                    setIsOpen,
                    meeting
                  )
                }
              }
              }
              onDeleteClick={(selectedId: string | number) =>
                deleteClickHandler(selectedId, meetingListRefetch)
              }
              paginationData={meeting?.meta}
              setCurrentPage={(pageNo: string) =>
                setCurrentPageMeeting(navigate, pageNo, pathname)
              }
              from_meeting={true}
            />
          </div>
        </Container>
      </div>

      <ModalContainer
        isOpen={isOpen}
        setIsopen={setIsOpen}
        title={modalEditData?.length !== 0 ? "Edit Meeting" : "Add Meeting"}
      >
        <AddMeetings
          setIsOpen={setIsOpen}
          modalEditData={modalEditData}
          refetch={meetingListRefetch}
        />
      </ModalContainer>
    </section>
  );
};

export default MeetingsIndex;
